import { useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import Actionbar from 'src/components/common/actionbar/Authactionbar';
import { Message } from 'src/components/common/form/Message';
import useUiuxStore from 'src/store/useUiuxStore';
import { useMouseContent } from 'src/utils/mouse/mouseContent';
import { HRM2010_R01Content } from './Content_HRM2010_R01';
import { DetailTable_HRM2010_R01 } from './DetailTable_HRM2010_R01';
import { HRM2010_R01DetailDto, HRM2010_R01HeaderDto } from './Dto_HRM2010_R01';
import { HRM2010_R01SearchSection } from './SearchSection_HRM2010_R01';
import { Table_HRM2010_R01 } from './Table_HRM2010_R01';

/** 위아래 그리드의 높이 조절 설정이다. */
const HEIGHT_RESIZER = {
    code: 'HRM2010_R01', type: 'height', storageKey: 'HRM2010_R01-split-height',
    min: 20, max: 80, default: 64,
} as const;

/** 검색 영역과 위아래 일일근태 편집 그리드를 조립한다. */
export const Container_HRM2010_R01 = () => {
    /** 두 그리드와 높이 조절 영역의 참조이다. */
    const gridRef = useRef<AgGridReact<HRM2010_R01HeaderDto>>(null);
    const detailGridRef = useRef<AgGridReact<HRM2010_R01DetailDto>>(null);
    const heightContainerRef = useRef<HTMLDivElement>(null);
    const heightInfoRef = useRef<HTMLDivElement>(null);
    const heightResizing = useRef(false);
    const { splitValue: height, handleMouseDown: startHeight } = useMouseContent({
        resizer: HEIGHT_RESIZER, isResizing: heightResizing,
        containerRef: heightContainerRef, infoRef: heightInfoRef,
    });
    const { setMessage } = useUiuxStore();
    const { fetchData, handleHeaderRowClick, handleDetailInsert, handleDeleteClick,
        handleSaveClick, handleBulkClick, handleExcelClick, handleEventAddClick, initContainerData,
        setActiveGridType } = HRM2010_R01Content({ gridRef, detailGridRef, setMessage });
    return <div className="content-container">
        {/* 공통 액션바의 조회·삭제·저장·Excel·초기화 동작을 연결한다. */}
        <Actionbar onFetchClick={fetchData} onDeleteClick={handleDeleteClick}
            onSaveClick={handleSaveClick} onExcelClick={handleExcelClick} onInitClick={initContainerData} />
        {/* 근무일자와 필터 및 일괄 정상출근 버튼이다. */}
        <HRM2010_R01SearchSection onBulkClick={handleBulkClick} />
        {/* 위아래 편집 그리드와 높이 조절 막대이다. */}
        <div className="flex flex-col flex-1 min-h-0 p-[12px] gap-[4px]" ref={heightContainerRef}>
            <div className="min-h-0" style={{ height: `${height}%` }}>
                <Table_HRM2010_R01 gridRef={gridRef} onSelect={handleHeaderRowClick}
                    setActiveGridType={setActiveGridType} />
            </div>
            <div className="h-[6px] bg-gray-100 cursor-row-resize hover:bg-gray-300"
                onMouseDown={event => startHeight('UD', event.nativeEvent)} />
            <div className="min-h-0" style={{ height: `${100 - height}%` }} ref={heightInfoRef}>
                <DetailTable_HRM2010_R01 gridRef={detailGridRef} handleInsertClick={handleDetailInsert}
                    handleDeleteClick={handleDeleteClick} handleEventAddClick={handleEventAddClick}
                    setActiveGridType={setActiveGridType} />
            </div>
        </div>
        {/* 화면 공통 하단 메시지이다. */}
        <Message />
    </div>;
};
